var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMembershipCheckboxIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5927_8183)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5927_8183)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9.5,
    r: 7.5,
    fill: "#262626",
    stroke: "#262626"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.473 6.30657C14.411 6.24409 14.3373 6.19449 14.256 6.16065C14.1748 6.1268 14.0876 6.10938 13.9996 6.10938C13.9116 6.10938 13.8245 6.1268 13.7433 6.16065C13.662 6.19449 13.5883 6.24409 13.5263 6.30657L8.55964 11.2799L6.47297 9.18657C6.40863 9.12441 6.33267 9.07554 6.24943 9.04274C6.16619 9.00993 6.07731 8.99385 5.98786 8.99539C5.8984 8.99694 5.81013 9.01609 5.72808 9.05176C5.64602 9.08742 5.5718 9.13889 5.50964 9.20324C5.44748 9.26759 5.39861 9.34355 5.3658 9.42679C5.333 9.51002 5.31691 9.59891 5.31846 9.68836C5.32001 9.77781 5.33916 9.86609 5.37482 9.94814C5.41049 10.0302 5.46196 10.1044 5.52631 10.1666L8.08631 12.7266C8.14828 12.7891 8.22202 12.8387 8.30326 12.8725C8.3845 12.9063 8.47163 12.9238 8.55964 12.9238C8.64765 12.9238 8.73479 12.9063 8.81603 12.8725C8.89727 12.8387 8.971 12.7891 9.03297 12.7266L14.473 7.28657C14.5406 7.22415 14.5946 7.14838 14.6316 7.06404C14.6685 6.97971 14.6876 6.88864 14.6876 6.79657C14.6876 6.70451 14.6685 6.61344 14.6316 6.5291C14.5946 6.44477 14.5406 6.369 14.473 6.30657Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5927_8183",
    x: 0,
    y: 0.5,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5927_8183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5927_8183",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5927_8183"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipCheckboxIc);
export default __webpack_public_path__ + "static/media/membershipCheckbox_ic.12c41fa60f23b373389a906f66bcf4be.svg";
export { ForwardRef as ReactComponent };